import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Empty, PortalHeading } from "./PortalLayout";
import { Textarea } from "@/components/ui/textarea";
import { useFetch } from "@/hooks/useFetch";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function Messages() {
  const { user } = useAuth();
  const { data, reload } = useFetch("/portal/messages");
  const [body, setBody] = useState("");
  const send = async (e) => {
    e.preventDefault();
    try { await api.post("/portal/messages", { body }); setBody(""); reload(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  const msgs = (data?.messages || []).slice().reverse();
  return (
    <div data-testid="portal-messages" className="max-w-3xl">
      <PortalHeading title="Messages" sub="Talk directly with your service advisor." />
      <div className="rounded-2xl bg-white p-5 space-y-3 max-h-[55vh] overflow-y-auto" data-testid="messages-thread">
        {!msgs.length && <Empty testId="messages-empty">No messages yet — say hello.</Empty>}
        {msgs.map((m) => {
          const mine = m.from_user_id === user?.id;
          return (
            <div key={m.id} className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm ${mine ? "ml-auto bg-[#020165] text-white" : "bg-[#F4F4F4]"}`} data-testid={`message-${m.id}`}>
              {!mine && <p className="text-[11px] font-bold text-[#F86900]">{m.staff_name || "Accelary Workshop"}</p>}
              <p className="whitespace-pre-wrap">{m.body}</p>
              <p className={`text-[10px] mt-1 ${mine ? "text-white/50" : "text-[#56585E]"}`}>{new Date(m.created_at).toLocaleString()}</p>
            </div>
          );
        })}
      </div>
      <form onSubmit={send} className="mt-3 flex gap-2">
        <Textarea required rows={2} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Write a message…" data-testid="message-input" />
        <button className="rounded-xl bg-[#F86900] text-[#0D141A] px-4" data-testid="message-send-button" aria-label="Send"><Send className="h-5 w-5" /></button>
      </form>
    </div>
  );
}
